module.exports = __webpack_public_path__ + "img/68.4.NH3-N.6e0a945e.png";